"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactMarkdown = require("react-markdown");
function Markdown({ value }) {
    return React.createElement(ReactMarkdown, { source: value });
}
exports.default = Markdown;
//# sourceMappingURL=index.js.map